import { render, staticRenderFns } from "./ActionsBlock.vue?vue&type=template&id=6379d054&scoped=true&"
import script from "./ActionsBlock.vue?vue&type=script&lang=js&"
export * from "./ActionsBlock.vue?vue&type=script&lang=js&"
import style0 from "./ActionsBlock.vue?vue&type=style&index=0&id=6379d054&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6379d054",
  null
  
)

export default component.exports